import { configurationConstants } from "../store/actions/types";
import { useAppDispatch, useAppSelector } from "./hooks";
export default function useConfiguration() {
    const dispatch = useAppDispatch();
    const userConfiguration = useAppSelector((state) => state.configuration.userConfiguration);
    const primaryBarSelection = useAppSelector((state) => state.configuration.primaryBarSelection);
    const updateConfiguration = (key, obj) => {
        let newUserConfiguration = Object.assign(Object.assign({}, userConfiguration), { [key]: obj });
        if (key === "Privacy") {
            delete newUserConfiguration.Accessories;
        }
        // newUserConfiguration = removeSucceedingEntries(key, newUserConfiguration);
        dispatch({
            type: configurationConstants.SET_CONFIGURATION,
            payload: newUserConfiguration,
        });
        // Updates selectionStatus
        if (!primaryBarSelection) {
            return;
        }
        if (!(primaryBarSelection === null || primaryBarSelection === void 0 ? void 0 : primaryBarSelection.multiSelect) ||
            (newUserConfiguration[primaryBarSelection.name] &&
                newUserConfiguration[primaryBarSelection.name].length ===
                    primaryBarSelection.options[0].options.length)) {
            dispatch({
                type: configurationConstants.UPDATE_SELECTION_STATUS,
                payload: { [primaryBarSelection.name]: true },
            });
            //   setSelectionStatus((prevState: any) => {
            //     return { ...prevState, [primaryBarSelection.name]: true };
            //   });
        }
        // setUserConfiguration(newUserConfiguration);
    };
    return { userConfiguration, updateConfiguration };
}
